import { API } from "./api";
import { JSONBody } from "./general";
import { convertScanner, Scanner } from "./scanner";
import { z } from "zod";

export interface Node {
  id: number;
  mac: string;
  name: string;
  scanners: Scanner[];
}

export const convertNode = (n: API.Node): Node => {
  return {
    id: n.id,
    mac: n.mac,
    name: n.name,
    scanners: n.scanners?.map(convertScanner) ?? [],
  }
}

export const convertNodes = (n: API.Node[]): Node[] => {
  return n.map(convertNode).sort((a, b) => a.name > b.name ? 1 : -1)
}

// Schema

export const convertNodeSchema = (node: Node): NodeSchema => {
  return {
    id: node.id,
    name: node.name
  }
}

export const nodeSchema = z.object({
  id: z.number().optional(),
  name: z.string().nonempty(),
});
export type NodeSchema = z.infer<typeof nodeSchema> & JSONBody;
